export default {
  'pages.titleOption': '操作',
  'pages.update': '编辑',
  'pages.new': '新建',
  'pages.view': '查看',
  'pages.export': '导出',
  'pages.import': '导入',
  'pages.clone': '克隆',
  'pages.chosen': '选择',
  'pages.item': '项',
  'pages.batchDeletion': '批量删除',
  'pages.createdAt': '创建时间',
  'pages.recommend': '推荐',
  'pages.copy': '复制',
  'pages.settings': '配置',
  'pages.generate.api': '生成代码',
  'pages.generate.sql': '生成sql',
  'pages.generate.view.code': '代码预览',
  'pages.sql.import': 'sql导入',
  'pages.json.import': 'json导入',
  'pages.layouts.userLayout.title': 'go-admin pro 是专门为go-admin订阅用户打造的脚手架',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/123456)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.searchUser.titleOption': '操作',
  'pages.searchUser.title': '用户管理',
  'pages.searchUser.update': '编辑',
  'pages.searchUser.userId': '编码',
  'pages.searchUser.username': '用户名',
  'pages.searchUser.nickName': '昵称',
  'pages.searchUser.phone': '手机',
  'pages.searchUser.status': '状态',
  'pages.searchUser.deptName': '部门',
  'pages.searchUser.createForm.newUser': '新用户',
  'pages.searchUser.updateForm.updateUser': '编辑用户',
  'pages.searchTable.updateForm.roleId.nameLabel': '角色',
  'pages.searchTable.updateForm.deptId.nameLabel': '部门',
  'pages.searchTable.updateForm.phone.nameLabel': '手机号',
  'pages.searchTable.updateForm.nickName.nameLabel': '昵称',
  'pages.searchTable.updateForm.post.nameLabel': '职位',
  'pages.searchTable.updateForm.status.nameLabel': '状态',
  'pages.searchTable.updateForm.sexType.nameLabel': '性别',
  'pages.searchTable.updateForm.username.nameLabel': '用户名',
  'pages.searchTable.updateForm.email.nameLabel': '电子邮箱',
  'pages.searchTable.updateForm.remark.nameLabel': '备注',
  'pages.searchTable.updateForm.roleId.nameRules': '请输入角色',
  'pages.searchTable.updateForm.deptId.nameRules': '请输入部门',
  'pages.searchTable.updateForm.phone.nameRules': '请输入手机号',
  'pages.searchTable.updateForm.nickName.nameRules': '请输入昵称',
  'pages.searchTable.updateForm.post.nameRules': '请选择职位',
  'pages.searchTable.updateForm.status.nameRules': '请选择状态',
  'pages.searchTable.updateForm.sexType.nameRules': '请选择性别',
  'pages.searchTable.updateForm.username.nameRules': '请输入用户名',
  'pages.searchTable.updateForm.email.nameRules': '请输入电子邮箱',
  'pages.searchUser.newUser': '新用户',
  'pages.searchUser.batchApproval': '批量',
  'pages.searchUser.batchDeletion': '批量删除',
  'pages.searchUser.resetPassword': '重置',
  'pages.searchUser.resetPasswordForm.resetPassword': '重置密码',
  'pages.searchTable.resetPasswordForm.password.nameRules': '密码',
  'pages.postManage.postId': '编码',
  'pages.postManage.postName': '名称',
  'pages.postManage.postCode': '代码',
  'pages.postManage.sort': '排序',
  'pages.postManage.status': '状态',
  'pages.postManage.createdAt': '创建时间',
  'pages.postManage.titleOption': '操作',
  'pages.postManage.update': '编辑',
  'pages.postManage.new': '新建',
  'pages.postManage.title': '岗位管理',
  'pages.postManage.createForm.newPost': '新岗位',
  'pages.postManage.updateForm.update': '编辑',
  'pages.postManage.updateForm.postName.nameLabel': '名称',
  'pages.postManage.updateForm.postCode.nameLabel': '代码',
  'pages.postManage.updateForm.sort.nameLabel': '排序',
  'pages.postManage.updateForm.status.nameLabel': '状态',
  'pages.postManage.updateForm.remark.nameLabel': '备注',
  'pages.deptManage.title': '部门管理',
  'pages.deptManage.deptId': '编码',
  'pages.deptManage.deptName': '名称',
  'pages.deptManage.sort': '排序',
  'pages.deptManage.status': '状态',
  'pages.deptManage.createdAt': '创建时间',
  'pages.deptManage.createForm.newDept': '新部门',
  'pages.deptManage.updateForm.updateDept': '编辑',
  'pages.deptManage.updateForm.parentId.nameLabel': '上级部门',
  'pages.deptManage.updateForm.deptName.nameLabel': '名称',
  'pages.deptManage.updateForm.leader.nameLabel': '负责人',
  'pages.deptManage.updateForm.phone.nameLabel': '电话',
  'pages.deptManage.updateForm.email.nameLabel': '邮箱',
  'pages.deptManage.updateForm.status.nameLabel': '状态',
  'pages.deptManage.updateForm.sort.nameLabel': '排序',
  'pages.roleManage.roleId': '编码',
  'pages.roleManage.roleName': '名称',
  'pages.roleManage.sort': '排序',
  'pages.roleManage.status': '状态',
  'pages.roleManage.createdAt': '创建时间',
  'pages.roleManage.title': '角色管理',
  'pages.roleManage.createForm.newRole': '新角色',
  'pages.roleManage.updateForm.updateRole': '编辑',
  'pages.roleManage.updateForm.basicConfig': '基本信息',
  'pages.roleManage.updateForm.roleName.nameLabel': '名称',
  'pages.roleManage.updateForm.roleKey.nameLabel': 'Key',
  'pages.roleManage.updateForm.roleSort.nameLabel': '排序',
  'pages.roleManage.updateForm.status.nameLabel': '状态',
  'pages.roleManage.updateForm.remark.nameLabel': '备注',
  'pages.roleManage.updateForm.remark.Placeholder': '请输入备注',
  'pages.roleManage.updateForm.remark.nameRules': '请输入备注！',
  'pages.roleManage.updateForm.menuStep.title': '角色权限',
  'pages.roleManage.updateForm.dataStep.title': '数据权限',
  'pages.roleManage.updateForm.dataScope': '范围',
  'pages.menuManage.title': '国际化key',
  'pages.menuManage.menuName': '中文名称',
  'pages.menuManage.component': '组件',
  'pages.menuManage.permission': '权限标记',
  'pages.menuManage.sort': '排序',
  'pages.menuManage.visible': '隐藏',
  'pages.menuManage.menuType': '类型',
  'pages.menuManage.createdAt': '创建时间',
  'pages.menuManage.newChildren': '子菜单',
  'pages.menuManage.table.title': '菜单管理',
  'pages.menuManage.createForm.newMenu': '新菜单',
  'pages.menuManage.updateForm.updateMenu': '编辑',
  'pages.menuManage.updateForm.parentId.nameLabel': '上级菜单',
  'pages.menuManage.updateForm.parentId.nameRules': '请选择上级菜单',
  'pages.menuManage.updateForm.title.nameLabel': '国际化key',
  'pages.menuManage.updateForm.title.nameRules': '请输入国际化key！',
  'pages.menuManage.updateForm.icon.nameLabel': 'icon',
  'pages.menuManage.updateForm.sort.nameLabel': '排序',
  'pages.menuManage.updateForm.sort.nameRules': '',
  'pages.menuManage.updateForm.menuType.nameLabel': '类型',
  'pages.menuManage.updateForm.menuName.nameLabel': '中文名称',
  'pages.menuManage.updateForm.menuName.nameRules': '',
  'pages.menuManage.updateForm.component.nameLabel': '组件',
  'pages.menuManage.updateForm.isFrame.nameLabel': '是否frame',
  'pages.menuManage.updateForm.open.nameLabel': '隐藏',
  'pages.menuManage.updateForm.path.nameLabel': '路径',
  'pages.menuManage.updateForm.permission.nameLabel': '权限',
  'pages.menuManage.createForm.icon': '选择icon',
  'pages.processManage.title': '流程管理',
  'pages.processManage.id': '编码',
  'pages.processManage.name': '名称',
  'pages.processManage.createdAt': '创建时间',
  'pages.processManage.updateForm.icon.nameLabel': 'icon',
  'pages.processManage.updateForm.classify.nameLabel': '分类',
  'pages.processManage.updateForm.name.nameLabel': '名称',
  'pages.processManage.createForm.newProcess': '新流程',
  'pages.processManage.createForm.icon': 'icon',
  'pages.workOrderManage.id': '编码',
  'pages.workOrderManage.title': '名称',
  'pages.workOrderManage.createdAt': '创建时间',
  'pages.workOrderManage.createForm.newWorkOrder': '新工单',
  'pages.deptManage.updateForm.updateWorkOrder': '编辑工单',
  'pages.workOrderManage.principals': '当前处理人',
  'pages.workOrderManage.processName': '流程',
  'pages.workOrderManage.stateName': '当前状态',
  'pages.workOrderManage.isEnd': '是否结束',
  'pages.workOrderManage.isDenied': '是否驳回',
  'pages.sysRequestLogManage.title': '请求日志',
  'pages.sysRequestLogManage.id': '编号',
  'pages.sysRequestLogManage.requestMethod': '请求方式',
  'pages.sysRequestLogManage.operName': '操作者',
  'pages.sysRequestLogManage.operUrl': '访问地址',
  'pages.sysRequestLogManage.operIp': '客户端ip',
  'pages.sysRequestLogManage.operLocation': '访问位置',
  'pages.sysRequestLogManage.operParam': '请求参数',
  'pages.sysRequestLogManage.operHeaders': 'Headers',
  'pages.sysRequestLogManage.status': '操作状态',
  'pages.sysRequestLogManage.operTime': '操作时间',
  'pages.sysRequestLogManage.jsonResult': '返回数据',
  'pages.sysRequestLogManage.remark': '备注',
  'pages.sysRequestLogManage.latencyTime': '耗时',
  'pages.sysRequestLogManage.userAgent': 'ua',
  'pages.sysRequestLogManage.updateForm.id.nameLabel': '编号',
  'pages.sysRequestLogManage.updateForm.requestMethod.nameLabel': '请求方式',
  'pages.sysRequestLogManage.updateForm.operName.nameLabel': '操作者',
  'pages.sysRequestLogManage.updateForm.operUrl.nameLabel': '访问地址',
  'pages.sysRequestLogManage.updateForm.operIp.nameLabel': '客户端ip',
  'pages.sysRequestLogManage.updateForm.operLocation.nameLabel': '访问位置',
  'pages.sysRequestLogManage.updateForm.operParam.nameLabel': '请求参数',
  'pages.sysRequestLogManage.updateForm.operHeaders.nameLabel': 'Headers',
  'pages.sysRequestLogManage.updateForm.status.nameLabel': '操作状态',
  'pages.sysRequestLogManage.updateForm.operTime.nameLabel': '操作时间',
  'pages.sysRequestLogManage.updateForm.jsonResult.nameLabel': '返回数据',
  'pages.sysRequestLogManage.updateForm.latencyTime.nameLabel': '耗时',
  'pages.sysRequestLogManage.updateForm.userAgent.nameLabel': 'ua',
  'pages.sysRequestLogManage.createForm.newSysRequestLog': '新请求日志',
  'pages.sysRequestLogManage.updateForm.updateSysRequestLog': '编辑请求日志',
  'pages.sysRequestLogManage.updateForm.viewSysRequestLog': '查看请求日志',

  'pages.sysOperateLogManage.title': '操作日志',
  'pages.sysOperateLogManage.logId': '编号',
  'pages.sysOperateLogManage.type': '操作类型',
  'pages.sysOperateLogManage.userName': '操作人',
  'pages.sysOperateLogManage.createdAt': '操作时间',
  'pages.sysOperateLogManage.description': '操作说明',
  'pages.sysOperateLogManage.updateForm.viewSysOperateLog': '查看操作日志',

  'pages.sysAbnormalLogManage.title': '操作日志',
  'pages.sysAbnormalLogManage.abId': '编号',
  'pages.sysAbnormalLogManage.url': '地址',
  'pages.sysAbnormalLogManage.ip': 'ip',
  'pages.sysAbnormalLogManage.method': '请求方式',
  'pages.sysAbnormalLogManage.userName': '操作人',
  'pages.sysAbnormalLogManage.createdAt': '操作时间',
  'pages.sysAbnormalLogManage.updateForm.viewSysAbnormalLog': '查看异常日志',

  'pages.sysApiManage.title': '接口管理',
  'pages.sysApiManage.path': '接口地址',
  'pages.sysApiManage.isHistory': '历史',
  'pages.sysApiManage.func': 'func',
  'pages.sysApiManage.bus': '业务',
  'pages.sysApiManage.project': '项目',
  'pages.sysApiManage.name': '名称',

  'pages.sysApiManage.updateForm.path.nameLabel': '接口地址',
  'pages.sysApiManage.updateForm.isHistory.nameLabel': '历史',
  'pages.sysApiManage.updateForm.func.nameLabel': 'func',
  'pages.sysApiManage.updateForm.bus.nameLabel': '业务',
  'pages.sysApiManage.updateForm.project.nameLabel': '项目',
  'pages.sysApiManage.updateForm.name.nameLabel': '名称',
  'pages.sysApiManage.updateForm.handle.nameLabel': '名称',
  'pages.sysApiManage.updateForm.type.nameLabel': '接口类型',
  'pages.sysApiManage.updateForm.method.nameLabel': '请求方式',

  'pages.sysApiManage.updateForm.type.nameRules': '请选择接口类型！',
  'pages.sysApiManage.updateForm.name.nameRules': '请输入接口名称！',

  'pages.sysConfigManage.title': '参数管理',
  'pages.sysConfigManage.configName': '名称',
  'pages.sysConfigManage.configKey': '键',
  'pages.sysConfigManage.configValue': '值',
  'pages.sysConfigManage.configType': '类型',
  'pages.sysConfigManage.remark': '备注',
  'pages.sysConfigManage.updateForm.configName.nameLabel': '名称',
  'pages.sysConfigManage.updateForm.configKey.nameLabel': '键',
  'pages.sysConfigManage.updateForm.configValue.nameLabel': '值',
  'pages.sysConfigManage.updateForm.configType.nameLabel': '类型',
  'pages.sysConfigManage.updateForm.remark.nameLabel': '备注',
  'pages.sysConfigManage.updateForm.formField.nameLabel': '组件',

  'pages.sysConfigManage.updateForm.configKey.nameRules': '请输入键！',
  'pages.sysConfigManage.updateForm.formField.nameRules': '请选择组件!',

  'pages.sysJobManage.jobName': 'Job名称',

  'pages.sysJobManage.updateForm.jobName.nameLabel': 'Job名称',
  'pages.sysJobManage.updateForm.jobType.nameLabel': 'Job类型',
  'pages.sysJobManage.updateForm.cronExpression.nameLabel': 'cron表达式',
  'pages.sysJobManage.updateForm.invokeTarget.nameLabel': '调用目标',
  'pages.sysJobManage.updateForm.args.nameLabel': '参数',
  'pages.sysJobManage.updateForm.status.nameLabel': '状态',

  'pages.sysJobManage.updateForm.jobName.nameRules': '请输入Job名称',
  'pages.sysJobManage.updateForm.jobType.nameRules': '请选择Job类型',
  'pages.sysJobManage.updateForm.cronExpression.nameRules': '请输入cron表达式',
  'pages.sysJobManage.updateForm.invokeTarget.nameRules': '请输入调用目标',
  'pages.sysJobManage.updateForm.args.nameRules': '请输入参数',
  'pages.sysJobManage.updateForm.status.nameRules': '请选择状态',

  'pages.sysDictTypeManage.title': '字典类型管理',
  'pages.sysDictTypeManage.dictId': '类型编码',
  'pages.sysDictTypeManage.dictName': '名称',
  'pages.sysDictTypeManage.dictType': 'key',
  'pages.sysDictTypeManage.status': '状态',
  'pages.sysDictTypeManage.remark': '备注',

  'pages.sysDictDataManage.title': '字典数据',
  'pages.sysDictDataManage.dictLabel': '名称',
  'pages.sysDictDataManage.dictValue': '值',
  'pages.sysDictDataManage.status': '状态',
  'pages.sysDictDataManage.remark': '备注',

  'pages.sysDictTypeManage.updateForm.dictId.nameLabel': '类型编码',
  'pages.sysDictTypeManage.updateForm.dictName.nameLabel': '名称',
  'pages.sysDictTypeManage.updateForm.dictType.nameLabel': 'key',
  'pages.sysDictTypeManage.updateForm.status.nameLabel': '状态',
  'pages.sysDictTypeManage.updateForm.remark.nameLabel': '备注',

  'pages.sysDictDataManage.updateForm.dictSort.nameLabel': '排序',
  'pages.sysDictDataManage.updateForm.dictLabel.nameLabel': '名称',
  'pages.sysDictDataManage.updateForm.dictValue.nameLabel': '值',
  'pages.sysDictDataManage.updateForm.dictType.nameLabel': '字典key',
  'pages.sysDictDataManage.updateForm.status.nameLabel': '状态',
  'pages.sysDictDataManage.updateForm.remark.nameLabel': '备注',

  'pages.tbCmsMenuManage.title': '导航管理',
  'pages.tbCmsMenuManage.id': '编码',
  'pages.tbCmsMenuManage.name': '页面名称',
  'pages.tbCmsMenuManage.type': '菜单类型',
  'pages.tbCmsMenuManage.link': '引用',
  'pages.tbCmsMenuManage.parent': '父节点',

  'pages.tbCmsMenuManage.updateForm.id.nameLabel': '编码',
  'pages.tbCmsMenuManage.updateForm.name.nameLabel': '页面名称',
  'pages.tbCmsMenuManage.updateForm.type.nameLabel': '菜单类型',
  'pages.tbCmsMenuManage.updateForm.link.nameLabel': '引用',
  'pages.tbCmsMenuManage.updateForm.parent.nameLabel': '父节点',

  'pages.tbCmsFriendlinkManage.title': '友情链接管理',
  'pages.tbCmsFriendlinkManage.id': '编码',
  'pages.tbCmsFriendlinkManage.name': '链接名称',
  'pages.tbCmsFriendlinkManage.link': '链接地址',

  'pages.tbCmsFriendlinkManage.updateForm.id.nameLabel': '编码',
  'pages.tbCmsFriendlinkManage.updateForm.name.nameLabel': '链接名称',
  'pages.tbCmsFriendlinkManage.updateForm.link.nameLabel': '链接地址',

  'pages.tbCmsArticleManage.listtitle': '文章管理',
  'pages.tbCmsArticleManage.id': '编码',
  'pages.tbCmsArticleManage.title': '标题',
  'pages.tbCmsArticleManage.mark': '页面标记',
  'pages.tbCmsArticleManage.source': '引用来源',
  'pages.tbCmsArticleManage.author': '作者',
  'pages.tbCmsArticleManage.category': '分类',
  'pages.tbCmsArticleManage.content': '内容',
  'pages.tbCmsArticleManage.file': '附件',
  'pages.tbCmsArticleManage.pubTime': '发布时间',

  'pages.tbCmsArticleManage.updateForm.id.nameLabel': '编码',
  'pages.tbCmsArticleManage.updateForm.title.nameLabel': '标题',
  'pages.tbCmsArticleManage.updateForm.mark.nameLabel': '页面标记',
  'pages.tbCmsArticleManage.updateForm.source.nameLabel': '引用来源',
  'pages.tbCmsArticleManage.updateForm.author.nameLabel': '作者',
  'pages.tbCmsArticleManage.updateForm.category.nameLabel': '分类',
  'pages.tbCmsArticleManage.updateForm.content.nameLabel': '内容',
  'pages.tbCmsArticleManage.updateForm.file.nameLabel': '附件',
  'pages.tbCmsArticleManage.updateForm.pubTime.nameLabel': '发布时间',

  'pages.tbCmsPageManage.listtitle': '页面管理',
  'pages.tbCmsPageManage.id': '编码',
  'pages.tbCmsPageManage.title': '页面名称',
  'pages.tbCmsPageManage.mark': '页面标记',
  'pages.tbCmsPageManage.source': '引用来源',
  'pages.tbCmsPageManage.author': '作者',
  'pages.tbCmsPageManage.content': '内容',
  'pages.tbCmsPageManage.pubTime': '发布时间',

  'pages.tbCmsPageManage.updateForm.id.nameLabel': '编码',
  'pages.tbCmsPageManage.updateForm.title.nameLabel': '页面名称',
  'pages.tbCmsPageManage.updateForm.mark.nameLabel': '页面标记',
  'pages.tbCmsPageManage.updateForm.source.nameLabel': '引用来源',
  'pages.tbCmsPageManage.updateForm.author.nameLabel': '作者',
  'pages.tbCmsPageManage.updateForm.content.nameLabel': '内容',
  'pages.tbCmsPageManage.updateForm.pubTime.nameLabel': '发布时间',

  'pages.agentInfoManage.listTitle': '代理客户端信息',
  'pages.agentInfoManage.id': '编码',
  'pages.agentInfoManage.agent': '代理名称',
  'pages.agentInfoManage.version': '代理版本',
  'pages.agentInfoManage.time': '最后上报时间',
  'pages.agentInfoManage.ip': '客户端ip',
  'pages.agentInfoManage.port': '端口号',
  'pages.agentInfoManage.mac': 'mac地址',
  'pages.agentInfoManage.authCode': '授权编码',
  'pages.agentInfoManage.updateForm.id.nameLabel': '编码',
  'pages.agentInfoManage.updateForm.agent.nameLabel': '代理名称',
  'pages.agentInfoManage.updateForm.version.nameLabel': '代理版本',
  'pages.agentInfoManage.updateForm.time.nameLabel': '最后上报时间',
  'pages.agentInfoManage.updateForm.ip.nameLabel': '客户端ip',
  'pages.agentInfoManage.updateForm.port.nameLabel': '端口号',
  'pages.agentInfoManage.updateForm.mac.nameLabel': 'mac地址',
  'pages.agentInfoManage.updateForm.authCode.nameLabel': '授权编码',

  'pages.blocksInfoManage.listTitle': '积木块',
  'pages.blocksInfoManage.id': '编码',
  'pages.blocksInfoManage.name': '积木名称',
  'pages.blocksInfoManage.introduction': '简介',
  'pages.blocksInfoManage.explanation': '说明',
  'pages.blocksInfoManage.version': '版本号',
  'pages.blocksInfoManage.minSupport': '最小支持版本',
  'pages.blocksInfoManage.maxSupport': '最大支持版本',
  'pages.blocksInfoManage.price': '价格',
  'pages.blocksInfoManage.frontend': '前端附件',
  'pages.blocksInfoManage.backend': '后端附件',
  'pages.blocksInfoManage.remark': '备注',
  'pages.blocksInfoManage.downloadCount': '下载次数',
  'pages.blocksInfoManage.status': '状态',
  'pages.blocksInfoManage.updateForm.id.nameLabel': '编码',
  'pages.blocksInfoManage.updateForm.name.nameLabel': '积木名称',
  'pages.blocksInfoManage.updateForm.introduction.nameLabel': '简介',
  'pages.blocksInfoManage.updateForm.explanation.nameLabel': '说明',
  'pages.blocksInfoManage.updateForm.version.nameLabel': '版本号',
  'pages.blocksInfoManage.updateForm.minSupport.nameLabel': '最小支持版本',
  'pages.blocksInfoManage.updateForm.maxSupport.nameLabel': '最大支持版本',
  'pages.blocksInfoManage.updateForm.price.nameLabel': '价格',
  'pages.blocksInfoManage.updateForm.frontend.nameLabel': '前端附件',
  'pages.blocksInfoManage.updateForm.backend.nameLabel': '后端附件',
  'pages.blocksInfoManage.updateForm.remark.nameLabel': '备注',
  'pages.blocksInfoManage.updateForm.downloadCount.nameLabel': '下载次数',
  'pages.blocksInfoManage.updateForm.status.nameLabel': '状态',

  'pages.tbSystemNoticeManage.listTitle': '系统通知表',
  'pages.tbSystemNoticeManage.id': '主键',
  'pages.tbSystemNoticeManage.title': '标题',
  'pages.tbSystemNoticeManage.content': '内容',
  'pages.tbSystemNoticeManage.type': '发给哪些用户',
  'pages.tbSystemNoticeManage.state': '状态',
  'pages.tbSystemNoticeManage.recipientId': '接受通知的用户',
  'pages.tbSystemNoticeManage.publishTime': '发布时间',
  'pages.tbSystemNoticeManage.updateForm.id.nameLabel': '主键',
  'pages.tbSystemNoticeManage.updateForm.title.nameLabel': '标题',
  'pages.tbSystemNoticeManage.updateForm.content.nameLabel': '内容',
  'pages.tbSystemNoticeManage.updateForm.type.nameLabel': '发给哪些用户',
  'pages.tbSystemNoticeManage.updateForm.state.nameLabel': '状态',
  'pages.tbSystemNoticeManage.updateForm.recipientId.nameLabel': '接受通知的用户',
  'pages.tbSystemNoticeManage.updateForm.publishTime.nameLabel': '发布时间',

  'pages.tbUserSystemNoticeManage.listTitle': '我的消息',
  'pages.tbUserSystemNoticeManage.id': '主键',
  'pages.tbUserSystemNoticeManage.state': '阅读状态',
  'pages.tbUserSystemNoticeManage.systemNoticeId': '标题',
  'pages.tbUserSystemNoticeManage.type': '消息类型',
  'pages.tbUserSystemNoticeManage.pullTime': '发布时间',
  'pages.tbUserSystemNoticeManage.recipientId': '接收通知的用户',
  'pages.tbUserSystemNoticeManage.updateForm.id.nameLabel': '主键',
  'pages.tbUserSystemNoticeManage.updateForm.state.nameLabel': '阅读状态',
  'pages.tbUserSystemNoticeManage.updateForm.systemNoticeId.nameLabel': '标题',
  'pages.tbUserSystemNoticeManage.updateForm.pullTime.nameLabel': '发布时间',
  'pages.tbUserSystemNoticeManage.updateForm.recipientId.nameLabel': '接收通知的用户',

  'pages.tbMManage.listTitle': '主表',
  'pages.tbMManage.id': '主键',
  'pages.tbMManage.title': '标题',
  'pages.tbMManage.amount': '金额',
  'pages.tbMManage.updateForm.id.nameLabel': '主键',
  'pages.tbMManage.updateForm.title.nameLabel': '标题',
  'pages.tbMManage.updateForm.amount.nameLabel': '金额',

  'pages.tbMManage.name': '品名',
  'pages.tbMManage.price': '单价',
  'pages.tbMManage.total': '数量',
  'pages.tbMManage.pId': '关系',
  'pages.tbMManage.updateForm.name.nameLabel': '品名',
  'pages.tbMManage.updateForm.price.nameLabel': '单价',
  'pages.tbMManage.updateForm.total.nameLabel': '数量',
  'pages.tbMManage.updateForm.pId.nameLabel': '关系',

  'pages.tbCompanyManage.listTitle': '客户',
  'pages.tbCompanyManage.id': '主键',
  'pages.tbCompanyManage.companyName': '公司名称',
  'pages.tbCompanyManage.companyType': '公司类型',
  'pages.tbCompanyManage.mainProducts': '主营产品',
  'pages.tbCompanyManage.country': '所属国家',
  'pages.tbCompanyManage.companyAddress': '公司地址',
  'pages.tbCompanyManage.purpose': '用途',
  'pages.tbCompanyManage.salesStatus': '销售状态',
  'pages.tbCompanyManage.grade': '等级',
  'pages.tbCompanyManage.source': '来源',
  'pages.tbCompanyManage.remark': '需求信息备注',
  'pages.tbCompanyManage.salespersonId': '所属业务员',
  'pages.tbCompanyManage.isPublic': '是否公海',
  'pages.tbCompanyManage.updateForm.id.nameLabel': '主键',
  'pages.tbCompanyManage.updateForm.companyName.nameLabel': '公司名称',
  'pages.tbCompanyManage.updateForm.companyType.nameLabel': '公司类型',
  'pages.tbCompanyManage.updateForm.mainProducts.nameLabel': '主营产品',
  'pages.tbCompanyManage.updateForm.country.nameLabel': '所属国家',
  'pages.tbCompanyManage.updateForm.companyAddress.nameLabel': '公司地址',
  'pages.tbCompanyManage.updateForm.purpose.nameLabel': '用途',
  'pages.tbCompanyManage.updateForm.salesStatus.nameLabel': '销售状态',
  'pages.tbCompanyManage.updateForm.grade.nameLabel': '等级',
  'pages.tbCompanyManage.updateForm.source.nameLabel': '来源',
  'pages.tbCompanyManage.updateForm.remark.nameLabel': '需求信息备注',
  'pages.tbCompanyManage.updateForm.salespersonId.nameLabel': '所属业务员',
  'pages.tbCompanyManage.updateForm.isPublic.nameLabel': '是否公海',

  'pages.tbCategoryManage.listTitle': '产品类型',
  'pages.tbCategoryManage.id': '主键',
  'pages.tbCategoryManage.pId': '父id',
  'pages.tbCategoryManage.code': '编码',
  'pages.tbCategoryManage.name': '名称',
  'pages.tbCategoryManage.updateForm.id.nameLabel': '主键',
  'pages.tbCategoryManage.updateForm.pId.nameLabel': '父id',
  'pages.tbCategoryManage.updateForm.code.nameLabel': '编码',
  'pages.tbCategoryManage.updateForm.name.nameLabel': '名称',

  'pages.tbProductManage.listTitle': '产品管理',
  'pages.tbProductManage.id': '主键',
  'pages.tbProductManage.name': '名称',
  'pages.tbProductManage.code': '编码',
  'pages.tbProductManage.category': '分类',
  'pages.tbProductManage.productType': '型号',
  'pages.tbProductManage.casNum': 'CAS号',
  'pages.tbProductManage.guidePrice': '指导报价',
  'pages.tbProductManage.costPrice': '成本价',
  'pages.tbProductManage.unit': '单位',
  'pages.tbProductManage.describe': '描述',
  'pages.tbProductManage.testReport': '检测报告',
  'pages.tbProductManage.img': '图片',
  'pages.tbProductManage.status': '状态',
  'pages.tbProductManage.notes': '备注',
  'pages.tbProductManage.updateForm.id.nameLabel': '主键',
  'pages.tbProductManage.updateForm.name.nameLabel': '名称',
  'pages.tbProductManage.updateForm.code.nameLabel': '编码',
  'pages.tbProductManage.updateForm.category.nameLabel': '分类',
  'pages.tbProductManage.updateForm.productType.nameLabel': '型号',
  'pages.tbProductManage.updateForm.casNum.nameLabel': 'CAS号',
  'pages.tbProductManage.updateForm.guidePrice.nameLabel': '指导报价',
  'pages.tbProductManage.updateForm.costPrice.nameLabel': '成本价',
  'pages.tbProductManage.updateForm.unit.nameLabel': '单位',
  'pages.tbProductManage.updateForm.describe.nameLabel': '描述',
  'pages.tbProductManage.updateForm.testReport.nameLabel': '检测报告',
  'pages.tbProductManage.updateForm.img.nameLabel': '图片',
  'pages.tbProductManage.updateForm.status.nameLabel': '状态',
  'pages.tbProductManage.updateForm.notes.nameLabel': '备注',

  'pages.tbOrderManage.listTitle': '订单管理',
  'pages.tbOrderManage.id': '主键',
  'pages.tbOrderManage.orderCode': '订单编号',
  'pages.tbOrderManage.customerId': '买家Id',
  'pages.tbOrderManage.customer': '买家',
  'pages.tbOrderManage.orderType': '订单类型',
  'pages.tbOrderManage.shippingFee': '运费',
  'pages.tbOrderManage.orderAmount': '订单总金额',
  'pages.tbOrderManage.payStatus': '付款状态',
  'pages.tbOrderManage.orderStatus': '订单状态',
  'pages.tbOrderManage.planedShippingTime': '预计发货时间',
  'pages.tbOrderManage.shippingTime': '发货时间',
  'pages.tbOrderManage.signingDate': '签收时间',
  'pages.tbOrderManage.attachments': '订单附件',
  'pages.tbOrderManage.notes': '备注',
  'pages.tbOrderManage.shipStatus': '发货状态',
  'pages.tbOrderManage.shipCode': '物流单号',
  'pages.tbOrderManage.followUpStatus': '样品跟进状态',
  'pages.tbOrderManage.batchPayment': '批量收款',
  'pages.tbOrderManage.batchShipping': '批量发货',
  'pages.tbOrderManage.batchApproval': '批量审批',
  'pages.tbOrderManage.createQuote': '创建报价',
  'pages.tbOrderManage.payment': '收款',
  'pages.tbOrderManage.shipping': '发货',
  'pages.tbOrderManage.signing': '签收',
  'pages.tbOrderManage.approval': '审批',
  'pages.tbOrderManage.quote': '报价',
  'pages.tbOrderManage.statistics.totalAmount': '订单总额',
  'pages.tbOrderManage.statistics.totalOrders': '订单数量',
  'pages.tbOrderManage.statistics.productTypes': '产品类型',
  'pages.tbOrderManage.statistics.pendingPayment': '待收款',
  'pages.tbOrderManage.statistics.pendingShipment': '待发货',
  'pages.tbOrderManage.statistics.completionRate': '完成率',
  'pages.tbOrderManage.statistics.sampleFeedback': '样品反馈',
  'pages.tbOrderManage.sampleFeedback': '样品反馈',
  'pages.tbOrderManage.productFeedback': '产品反馈',
  'pages.tbOrderManage.orderFeedback': '订单反馈',
  'pages.tbOrderManage.feedback.rating': '评分',
  'pages.tbOrderManage.feedback.usageExperience': '使用感受',
  'pages.tbOrderManage.feedback.acceptanceLevel': '接受度',
  'pages.tbOrderManage.feedback.testResults': '检测试用结果',
  'pages.tbOrderManage.feedback.suggestions': '改进建议',
  'pages.tbOrderManage.feedback.overallRating': '整体满意度',
  'pages.tbOrderManage.feedback.overallComments': '整体评价',
  'pages.tbOrderManage.feedback.packagingQuality': '包装质量',
  'pages.tbOrderManage.feedback.serviceQuality': '服务质量',
  'pages.tbOrderManage.feedback.repurchaseIntention': '再次购买意向',
  'pages.tbOrderManage.feedback.recommendationLevel': '推荐指数',
  'pages.tbOrderManage.updateForm.id.nameLabel': '主键',
  'pages.tbOrderManage.updateForm.orderCode.nameLabel': '订单编号',
  'pages.tbOrderManage.updateForm.customerId.nameLabel': '买家Id',
  'pages.tbOrderManage.updateForm.customer.nameLabel': '买家',
  'pages.tbOrderManage.updateForm.orderType.nameLabel': '订单类型',
  'pages.tbOrderManage.updateForm.shippingFee.nameLabel': '运费',
  'pages.tbOrderManage.updateForm.orderAmount.nameLabel': '订单总金额',
  'pages.tbOrderManage.updateForm.payStatus.nameLabel': '付款状态',
  'pages.tbOrderManage.updateForm.orderStatus.nameLabel': '订单状态',
  'pages.tbOrderManage.updateForm.planedShippingTime.nameLabel': '预计发货时间',
  'pages.tbOrderManage.updateForm.shippingTime.nameLabel': '发货时间',
  'pages.tbOrderManage.updateForm.signingDate.nameLabel': '签收时间',
  'pages.tbOrderManage.updateForm.attachments.nameLabel': '订单附件',
  'pages.tbOrderManage.updateForm.notes.nameLabel': '备注',
  'pages.tbOrderManage.updateForm.shipStatus.nameLabel': '发货状态',
  'pages.tbOrderManage.updateForm.shipCode.nameLabel': '物流单号',
  'pages.tbOrderManage.updateForm.followUpStatus.nameLabel':
    '样品跟进状态:10等待反馈、20反馈完成、30样品试用中',

  // 时间令牌管理相关
  'pages.timeToken.title': '时间令牌管理',
  'pages.timeToken.description':
    '管理系统中的所有时间令牌，包括查看状态、撤销令牌和配额监控等功能。',
  'pages.timeToken.device': '设备信息',
  'pages.timeToken.license': '许可证',
  'pages.timeToken.hash': '令牌哈希',
  'pages.timeToken.usage': '使用次数',
  'pages.timeToken.stats.title': '统计面板',
  'pages.timeToken.list.title': '令牌列表',
  'pages.timeToken.usage.title': '使用统计',
  'pages.timeToken.analysis.title': '高级分析',
  'pages.timeToken.id': '令牌ID',
  'pages.timeToken.name': '令牌名称',
  'pages.timeToken.user': '分配用户',
  'pages.timeToken.status': '状态',
  'pages.timeToken.quota': '配额',
  'pages.timeToken.used': '已使用',
  'pages.timeToken.remaining': '剩余',
  'pages.timeToken.expires': '过期时间',
  'pages.timeToken.createdAt': '创建时间',
  'pages.timeToken.updatedAt': '更新时间',
  'pages.timeToken.action.adjust': '调整配额',
  'pages.timeToken.action.view': '查看详情',
  'pages.timeToken.action.revoke': '撤销令牌',
  'pages.timeToken.action.delete': '删除令牌',
  'pages.timeToken.action.enable': '启用',
  'pages.timeToken.action.disable': '禁用',
  'pages.timeToken.status.active': '激活',
  'pages.timeToken.status.inactive': '未激活',
  'pages.timeToken.status.expired': '已过期',
  'pages.timeToken.status.suspended': '已暂停',
  'pages.timeToken.modal.adjustQuota.title': '调整配额',
  'pages.timeToken.modal.adjustQuota.reason': '调整原因',
  'pages.timeToken.modal.adjustQuota.reason.placeholder': '请输入调整原因',
  'pages.timeToken.modal.adjustQuota.newQuota': '新配额',
  'pages.timeToken.modal.adjustQuota.newQuota.placeholder': '请输入新的配额值',
  'pages.timeToken.modal.adjustQuota.submit': '确认调整',
  'pages.timeToken.modal.adjustQuota.cancel': '取消',
  'pages.timeToken.usage.chart.daily': '每日使用情况',
  'pages.timeToken.usage.chart.trend': '使用趋势',
  'pages.timeToken.usage.chart.distribution': '使用分布',
  'pages.timeToken.usage.summary.total': '总计',
  'pages.timeToken.usage.summary.active': '活跃',
  'pages.timeToken.usage.summary.expired': '过期',
  'pages.timeToken.usage.summary.suspended': '暂停',
  'pages.timeToken.analysis.efficiency.title': '效率分析',
  'pages.timeToken.analysis.efficiency.score': '效率得分',
  'pages.timeToken.analysis.efficiency.rank': '效率排名',
  'pages.timeToken.analysis.anomaly.title': '异常检测',
  'pages.timeToken.analysis.anomaly.type': '异常类型',
  'pages.timeToken.analysis.anomaly.description': '异常描述',
  'pages.timeToken.analysis.optimization.title': '优化建议',
  'pages.timeToken.analysis.optimization.suggestion': '建议',
  'pages.timeToken.analysis.optimization.impact': '预期影响',
  'pages.timeToken.analysis.underused.title': '使用不足令牌',
  'pages.timeToken.analysis.highperformance.title': '高性能令牌',
  'pages.timeToken.analysis.bestpractice': '最佳实践',

  // PAM 安全管理相关
  'pages.pam.security.title': '安全管理',
  'pages.pam.security.description': '管理和监控PAM系统的安全事件、硬件变更和设备诊断信息',

  // 硬件变更日志
  'pages.pam.security.hardwareChanges.title': '硬件变更日志',
  'pages.pam.security.hardwareChanges.description': '监控和管理设备硬件变更情况',
  'pages.pam.security.hardwareChanges.changeType': '变更类型',
  'pages.pam.security.hardwareChanges.changeSource': '变更来源',
  'pages.pam.security.hardwareChanges.componentChanged': '变更组件',
  'pages.pam.security.hardwareChanges.severityLevel': '严重级别',
  'pages.pam.security.hardwareChanges.impactDescription': '影响描述',
  'pages.pam.security.hardwareChanges.status': '处理状态',
  'pages.pam.security.hardwareChanges.handledBy': '处理人',
  'pages.pam.security.hardwareChanges.handledAt': '处理时间',
  'pages.pam.security.hardwareChanges.detectedAt': '检测时间',
  'pages.pam.security.hardwareChanges.verificationStatus': '验证状态',
  'pages.pam.security.hardwareChanges.verificationNotes': '验证备注',
  'pages.pam.security.hardwareChanges.action.review': '审核',
  'pages.pam.security.hardwareChanges.action.approve': '批准',
  'pages.pam.security.hardwareChanges.action.reject': '拒绝',

  // 设备诊断信息
  'pages.pam.security.deviceDiagnostics.title': '设备诊断信息',
  'pages.pam.security.deviceDiagnostics.description': '查看设备硬件诊断和基线信息',
  'pages.pam.security.deviceDiagnostics.osFamily': '操作系统系列',
  'pages.pam.security.deviceDiagnostics.osVersion': '操作系统版本',
  'pages.pam.security.deviceDiagnostics.architecture': '系统架构',
  'pages.pam.security.deviceDiagnostics.cpuFamily': 'CPU系列',
  'pages.pam.security.deviceDiagnostics.memoryGB': '内存大小(GB)',
  'pages.pam.security.deviceDiagnostics.macPrefix': 'MAC地址前缀',
  'pages.pam.security.deviceDiagnostics.cpuModelMasked': 'CPU型号(脱敏)',
  'pages.pam.security.deviceDiagnostics.diskModelMasked': '硬盘型号(脱敏)',
  'pages.pam.security.deviceDiagnostics.componentHashes': '组件哈希',
  'pages.pam.security.deviceDiagnostics.fingerprintVersion': '指纹版本',
  'pages.pam.security.deviceDiagnostics.collectedAt': '收集时间',

  // 安全仪表板
  'pages.pam.security.dashboard.title': '安全仪表板',
  'pages.pam.security.dashboard.description': '安全状态概览和风险分析',
  'pages.pam.security.dashboard.overview.title': '安全概览',
  'pages.pam.security.dashboard.threats.title': '威胁统计',
  'pages.pam.security.dashboard.risks.title': '风险分析',
  'pages.pam.security.dashboard.trends.title': '安全趋势',
  'pages.pam.security.dashboard.alerts.title': '安全告警',
  'pages.pam.security.dashboard.stats.totalEvents': '总事件数',
  'pages.pam.security.dashboard.stats.highRiskEvents': '高风险事件',
  'pages.pam.security.dashboard.stats.pendingReviews': '待审核事件',
  'pages.pam.security.dashboard.stats.resolvedThreats': '已解决威胁',

  // 通用安全相关术语
  'pages.pam.security.riskLevel.low': '低风险',
  'pages.pam.security.riskLevel.medium': '中风险',
  'pages.pam.security.riskLevel.high': '高风险',
  'pages.pam.security.riskLevel.critical': '严重风险',
  'pages.pam.security.status.pending': '待处理',
  'pages.pam.security.status.reviewed': '已审核',
  'pages.pam.security.status.resolved': '已解决',
  'pages.pam.security.status.ignored': '已忽略',
  'pages.pam.security.eventLevel.info': '信息',
  'pages.pam.security.eventLevel.warning': '警告',
  'pages.pam.security.eventLevel.error': '错误',
  'pages.pam.security.eventLevel.critical': '严重',
  'pages.pam.security.export': '导出日志',
  'pages.pam.security.refresh': '刷新数据',
  'pages.pam.security.filter': '筛选条件',
  'pages.pam.security.search': '搜索',
  'pages.pam.security.dateRange': '日期范围',
  'pages.pam.security.details': '详细信息',

  // 状态文本翻译
  'pages.pam.security.status.success': '成功',
  'pages.pam.security.status.failure': '失败',
  'pages.pam.security.status.unknown': '未知',
  'pages.pam.security.riskLevel.critical.text': '严重',
  'pages.pam.security.riskLevel.high.text': '高',
  'pages.pam.security.riskLevel.medium.text': '中',
  'pages.pam.security.riskLevel.low.text': '低',

  // 事件类型翻译
  'pages.pam.security.eventType.device_limit_exceeded': '设备数量超限',
  'pages.pam.security.eventType.device_registration_success': '设备注册成功',
  'pages.pam.security.eventType.device_validation_success': '设备验证成功',
  'pages.pam.security.eventType.device_validation_failed': '设备验证失败',
  'pages.pam.security.eventType.fingerprint_mismatch': '设备指纹验证失败',
  'pages.pam.security.eventType.hardware_change_detected': '硬件变更检测',
  'pages.pam.security.eventType.unauthorized_access': '未授权访问',
  'pages.pam.security.eventType.license_validation_failed': '许可证验证失败',

  // 事件分类翻译
  'pages.pam.security.eventCategory.access': '访问',
  'pages.pam.security.eventCategory.authentication': '认证',
  'pages.pam.security.eventCategory.authorization': '授权',
  'pages.pam.security.eventCategory.policy': '策略',
  'pages.pam.security.eventCategory.system': '系统',
  'pages.pam.security.eventCategory.audit': '审计',

  // 事件级别翻译 (已在上面定义，移除重复)
  'pages.pam.security.eventLevel.high': '高',
  'pages.pam.security.eventLevel.medium': '中',
  'pages.pam.security.eventLevel.low': '低',

  // 安全仪表板翻译
  'pages.pam.security.dashboard.fetch.error': '获取仪表板数据失败',
  'pages.pam.security.dashboard.trend.error': '获取趋势数据失败',
  'pages.pam.security.dashboard.refresh.error': '刷新统计数据失败',
  'pages.pam.security.dashboard.eventType': '事件类型',
  'pages.pam.security.dashboard.eventDescription': '描述',

  // 代码自动插入标记(勿删)
};
